import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GuiFlowService } from '../../___LOGIC/__gui/gui-flow.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-edit-contract-modal',
  templateUrl: './edit-contract-modal.component.html',
  styleUrls: ['./edit-contract-modal.component.css']
})
export class EditContractModalComponent implements OnInit {

  debug = environment.debugMode;
  files: any = {
    formulario: null,
    cuestionario: null
  };

  loading = false;
  paymentLink;
  price;
  adminEmail = environment.userMail;
  
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,private dialogRef: MatDialogRef<EditContractModalComponent>,private http: HttpClient,private guiFlow: GuiFlowService) {}

  ngOnInit(): void {}

  save() {
    switch(this.data.contract.status){
      case '4':
        this.saveDocsAndNotifyUser();
        break;
      case '7':
        this.savePaymentLink();
        break;
      case '9':
        this.saveCertificadoAndNotifyUser();
        break;
    }
  }

  /* STEP 4 - ENVIAR ASISA DOCS */
  saveDocsAndNotifyUser(){
    this.submitDocuments();
  }

  areFilesUploaded(){
    if(this.debug){
      return true;
    }else{
      return this.files.formulario && this.files.cuestionario;
    }
  }

  submitDocuments(){
    if (!this.areFilesUploaded()) {
      this.guiFlow.openSimpleSnackBar('Por favor sube ambos documentos antes de continuar.','error');
      return;
    }
    debugger
    const upload = (file: File, description: string,file_id: string) => {
      const formData = new FormData();
      formData.append('FK_ID_omnibusContract', this.data.contract.id.toString());
      formData.append('description', description);
      formData.append('file', file);
      formData.append('file_id', file_id);

      return this.http.post('https://app.voyjaleas.com/myapp/fileManager/upload_document.php?queryParam1='+this.data.contract.status, formData).toPromise();
    };

    this.loading = true;
    Promise.all([
      upload(this.files.formulario, 'FormularioParaRellenar','formulario'),
      upload(this.files.cuestionario, 'CuestionarioParaRellenar','cuestionario')
    ])
    .then(responses => {
      const contractUpdated = {
        status: 5,
        price: this.price
      };

      this.http.put('https://app.voyjaleas.com/myapp/put/updateRow.php?table=omnibusContract&id='+this.data.contract.id,contractUpdated)
      .subscribe(
        (response) => {
          this.guiFlow.openSimpleSnackBar('Documentos subidos correctamente','success');
          this.loading = false;
          this.sendNotificationEmails();
        },
        (error) => {
          console.log(error);
          this.loading = false;
        }
      );
      this.closeModal();
      console.log('Respuestas:', responses);
    })
    .catch(err => {
      console.error('Error al subir archivos', err);
      alert('Hubo un error al subir los documentos.');
    });
  }

  prepareEmailConfigObject(processCode){
    let emailConfig;
    switch(processCode){
      //STEP 4
      case 'admin4':
        emailConfig = {
          template: 'docsReady4',
          emailTo: this.data.studentInfo.email,
          subject: 'Seguro Medico: descarga la documentación necesaria para el siguiente paso.',
          from: '<info@voyjaleas.com>',
          fromLabel: 'VoyJaleas App',
          tokenSeguro: this.data.contract.token,
          name: this.data.studentInfo.name,
          lastname: this.data.studentInfo.lastname1,
          price: this.price? this.price : ''
        }
        break;
      // STEP 7
      case 'admin7':
        emailConfig = {
          template: 'seguroPaymentLink',
          emailTo: this.data.studentInfo.email,
          subject: 'Seguro Medico: enlace de pago seguro.',
          from: '<info@voyjaleas.com>',
          fromLabel: 'VoyJaleas App',
          mainButtonLink: this.paymentLink,
          tokenSeguro: this.data.contract.token,
          name: this.data.studentInfo.name,
          lastname: this.data.studentInfo.lastname1,
          startDate: this.data.contract.startDate,
          endDate: this.data.contract.endDate
        }
        break;
      // STEP 9
      case 'admin9':
          emailConfig = {
            template: 'certificadoListo9',
            emailTo: this.data.studentInfo.email,
            subject: 'Seguro Medico: certificado de cobertura listo!',
            from: '<info@voyjaleas.com>',
            fromLabel: 'VoyJaleas App',
            tokenSeguro: this.data.contract.token,
            name: this.data.studentInfo.name,
            lastname: this.data.studentInfo.lastname1
          }
          break;
      default:
          break;
    }
    return emailConfig;
  }

  sendOmnibusProcessEmail(processCode){
    return this.http.post('https://app.voyjaleas.com/myapp/email/notifyAdmin.php',this.prepareEmailConfigObject(processCode)).toPromise();
  }

  sendNotificationEmails(){
    switch(this.data.contract.status){
      //STEP 4
      case "4":
        //Notify the admin
        this.sendOmnibusProcessEmail('admin4');
        break;
      //STEP 7
      case "7":
        //Notify the client of payment link is ready
        this.sendOmnibusProcessEmail('admin7');
        break;
      //STEP 9
      case "9":
        //Notify the client of PDF is ready
        this.sendOmnibusProcessEmail('admin9');
        break;
      default:
        break;
    }
  }

  /* STEP 7 - ENVIAR ENLACE DE PAGO */
  savePaymentLink(){
    this.loading =  true;

    const contractUpdated = {
      status: 8
    };

    this.http.put('https://app.voyjaleas.com/myapp/put/updateRow.php?table=omnibusContract&id='+this.data.contract.id,contractUpdated)
    .subscribe(
      (response) => {
        this.closeModal();
        this.guiFlow.openSimpleSnackBar('Link enviado','success');
        this.loading = false;
        this.sendNotificationEmails();
      },
      (error) => {
        this.guiFlow.openSimpleSnackBar('Error','error');
        console.log(error);
        this.loading = false;
      }
    );
  }
  
  /* STEP 9 - UPLOAD CERTIFICADO COBERTURA Y NOTIFICAR */
  saveCertificadoAndNotifyUser(){
    this.loading = true;
    let file = this.files.comprobante;
    let description = 'Comprobante cobertura en PDF';
    let fileId = 'comprobantePdf';
    const formData = new FormData();
    formData.append('FK_ID_omnibusContract', this.data.contract.id.toString());
    formData.append('description', description);
    formData.append('file', file);
    formData.append('file_id', fileId);
    this.http.post('https://app.voyjaleas.com/myapp/fileManager/upload_document.php?queryParam1='+this.data.contract.status, formData).toPromise();
    // UPDATE STATUS OF CONTRACT
    const contractUpdated = {
      status: 10
    }
    this.updateContractInfo(contractUpdated);
    
    // SEND EMAIL TO CLIENT
    this.sendNotificationEmails();
  }

  updateContractInfo(p_contractUpdated){
    this.http.put(
      'https://app.voyjaleas.com/myapp/put/updateRow.php?table=omnibusContract&id='+this.data.contract.id,
      p_contractUpdated
    ).subscribe(
        (response) => {
          this.loading = false;
          },
        (error) => {
          this.guiFlow.openSimpleSnackBar('Error','error');            
          console.log(error);
          this.loading = false;
        }
    )
  }

  getProcessStatus(status){
    switch(status){
      case '0':
        return 'No comenzado';
      case '1':
        return 'Detalles seguro y estudios';
      case '2':
        return 'Datos personales';
      case '3':
        return 'Subir docs';
      case '4':
        return 'Generarando docs seguro';
      case '5':
        return 'Rellenar/firmar docs';
      case '6':
          return 'Subir docs';
      case '7':
        return 'Aprobación ASISA';
    }
  }

  isCurrentStatus(status){
    return this.data.contract.status == status;
  }

  localSaveFile(event){
    this.files[event.fileId] = event.file;
  }

  closeModal() {
    this.dialogRef.close(); // you can also pass data: this.dialogRef.close('someData');
  }

}
